/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-plusplus */
import { DeleteOutlined, InboxOutlined } from "@ant-design/icons";
import { Flex } from "@components/flex/flex";
import { TableIcon } from "@components/table/tableStyle";
import { cloudinaryUpload } from "@utils/cloudinary";
import { toBase64 } from "@utils/convertToBase64";
import { allowedExtensions, isImageOrPdf } from "@utils/isImageOrPdf";
import { Button, Image, List, Upload } from "antd";
import * as React from "react";
import { FormattedMessage } from "react-intl";

const MAX_UPLOAD_SIZE = 2000000; // 2MB. Is set in Bytes
export const FALLBACK_IMAGE = "data:image/png;base64,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";

interface MultiImageUpload {
    onSuccessfulUpload: (urls: string[]) => void;
    onFailedUpload: (fileNames: string[]) => void;
}

interface ImageList {
    fileName: string;
    base64: string;
    errors: {
        id: string;
        values?: {[key: string]: string}
    }[];
}

export const MultiImageUpload: React.FC<MultiImageUpload> = (props) => {
    const { onSuccessfulUpload, onFailedUpload } = props;

    const [images, setImages] = React.useState<ImageList[]>([]);
    const [isUploading, setIsUploading] = React.useState(false);

    const removeImage = (fileName: string) => {
        setImages(images.filter(image => image.fileName !== fileName));
    };

    const beforeUpload = async (_, files) => {
        const newImages: ImageList[] = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            const image: ImageList = {
                fileName: file.name,
                base64: "",
                errors: []
            };

            if (!isImageOrPdf(image.fileName)) {
                image.errors.push({
                    id: "upload.invalidFileType",
                    values: { types: allowedExtensions.join(", ") }
                });
            }

            if (file.size > MAX_UPLOAD_SIZE) {
                image.errors.push({ id: "upload.maxFileExceeded" });
            }

            if (image.errors.length === 0) {
                const data = await toBase64(file);
                if (data) {
                    image.base64 = data;
                } else {
                    image.errors.push({ id: "upload.processingFailed" });
                }
            }

            newImages.push(image);
        }

        setImages([...images, ...newImages]);
    };

    const renderDescription = (image: ImageList) => {
        if (!image.errors.length) {
            return <FormattedMessage id="process.success" />;
        }

        return (
            <span className="manual-error-text">
                {image.errors.map(err => <FormattedMessage id={err.id} values={err.values} />)}
            </span>
        );
    };

    const clearImages = () => {
        setImages([]);
    };

    const handleUpload = async () => {
        setIsUploading(true);
        const successfulUploads: string[] = [];
        const failedUploads: string[] = [];
        let newState = images;

        for (let i = 0; i < images.length; i++) {
            const image = images[i];

            if (image.errors.length || !image.base64.length) {
                failedUploads.push(image.fileName);
                continue;
            }

            const response = await cloudinaryUpload(image.base64);

            if (response && response.url) {
                successfulUploads.push(response.url);
                newState = newState.filter(img => img.fileName !== image.fileName);
            } else {
                failedUploads.push(image.fileName);
            }
        }

        setIsUploading(false);
        setImages(newState);
        onSuccessfulUpload(successfulUploads);
        onFailedUpload(failedUploads);
    };

    return (
        <React.Fragment>
            <Upload.Dragger
                multiple
                beforeUpload={beforeUpload}
                accept="image/*"
            >
                <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                <p className="ant-upload-text"><FormattedMessage id="draganddrop.dragtoadd" /></p>
            </Upload.Dragger>
            {images.length ? (
                <List
                    dataSource={images}
                    renderItem={image => {
                        const description = renderDescription(image);
                        return (
                            <List.Item key={image.fileName}>
                                <List.Item.Meta
                                    avatar={<Image width={50} height={50} src={image.base64} fallback={FALLBACK_IMAGE} />}
                                    title={image.fileName}
                                    description={description}
                                />
                                <a onClick={() => removeImage(image.fileName)}>
                                    <TableIcon as={DeleteOutlined} />
                                </a>
                            </List.Item>
                        );
                    }}
                />
            ) : null}
            <Flex style={{ marginTop: "12px" }} justifyContent="flex-end">
                <Button onClick={clearImages} style={{ marginRight: "12px" }} disabled={!images.length}><FormattedMessage id="clearList" /></Button>
                <Button loading={isUploading} onClick={handleUpload} type="primary" disabled={!images.length}><FormattedMessage id="uploadAndInsert" /></Button>
            </Flex>
        </React.Fragment>
    );
};
